import { useNavigate } from 'react-router-dom'
import { Input, Select, Typography } from 'antd'
import Card from 'components/card/Card'
import Errors from 'components/errors/Errors'
import { IconSearch } from 'components/icons'
import ButtonLink from 'components/button/Button'
import {
  AdminsFinanceGetVendorListResponseItem,
  VendorDirectionEnum,
  VendorSortFieldEnum,
  VendorStatusEnum,
  VendorTypeEnum,
} from 'generated/api'
import { DropDownVendorStatus, DropDownVendorType } from 'constants/dropdown'
import VendorsTable from './VendorsTable'
import Pagination from 'components/pagination/Pagination'

interface VendorIndexProps {
  statusFetch: 'loading' | 'success' | 'failed'
  data: AdminsFinanceGetVendorListResponseItem[]
  name: string
  type: VendorTypeEnum
  status: VendorStatusEnum
  sortField: VendorSortFieldEnum
  sortBy: VendorDirectionEnum
  limit: number
  pagination: {
    page: number
    total: number
  }
  onFetchVendor: () => void
  onChangeName: (keyword: string) => void
  onSearchName: () => void
  onChangeType: (type: VendorTypeEnum) => void
  onChangeStatus: (status: VendorStatusEnum) => void
  onChangeLimit: (limit: number) => void
  onChangePage: (page: number) => void
  setSortingVendor: (columnKey: VendorSortFieldEnum) => void
}

function VendorsIndex(props: VendorIndexProps) {
  const navigate = useNavigate()

  const {
    statusFetch,
    type,
    data,
    name,
    limit,
    status,
    sortField,
    sortBy,
    pagination,
    onChangeName,
    onSearchName,
    onChangeType,
    onChangeStatus,
    onFetchVendor,
    onChangeLimit,
    onChangePage,
    setSortingVendor,
  } = props

  const isLoading = statusFetch === 'loading'
  const isFailed = statusFetch === 'failed'

  return (
    <Card loading={isLoading} className="rounded-xl p-0 pb-2">
      <Card.Header className="sticky-card-header block xl:flex py-2 px-4 justify-between border-b border-solid border-[#E5E5E7]">
        <div className="xl:w-1/5 mb-4 xl:mb-0 self-center">
          <Typography.Text className="text-xs font-medium text-[#3F454D]">
            Daftar Vendor
          </Typography.Text>
        </div>
        <div className="xl:w-4/5 mb-4 xl:mb-0">
          <div className="xl:flex xl:flex-row xl:gap-4">
            <div className="xl:w-2/5 mb-4 xl:mb-0">
              <Input
                data-testid="input_name"
                suffix={<IconSearch />}
                className="input-search"
                placeholder="Cari Nama Vendor"
                disabled={isLoading}
                style={{ height: 40 }}
                value={name}
                onChange={({ target: { value } }) => onChangeName(value)}
                onPressEnter={onSearchName}
              />
            </div>
            <div className="xl:w-2/5 mb-4 xl:mb-0">
              <Select
                data-testid="select_type"
                className="dropdown-search"
                style={{ height: 40 }}
                value={type}
                onChange={(vendorType: VendorTypeEnum) => onChangeType(vendorType)}
              >
                {DropDownVendorType.map(status => {
                  return (
                    <Select.Option key={status.value} value={status.value}>
                      {status.label}
                    </Select.Option>
                  )
                })}
              </Select>
            </div>
            <div className="xl:w-2/5 mb-4 xl:mb-0">
              <Select
                className="dropdown-search"
                style={{ height: 40 }}
                value={status}
                onChange={(productStatus: VendorStatusEnum) => onChangeStatus(productStatus)}
              >
                {DropDownVendorStatus.map(status => {
                  return (
                    <Select.Option key={status.value} value={status.value}>
                      {status.label}
                    </Select.Option>
                  )
                })}
              </Select>
            </div>
            <div className="xl:w-2/5 mb-4 xl:mb-0">
              <ButtonLink
                data-testid="button_add_vendor"
                variant="solid-primary"
                block={true}
                label="Tambah"
                className="text-sm h-full"
                onClick={() => navigate('/inventory/vendors/create')}
              />
            </div>
          </div>
        </div>
      </Card.Header>
      {isFailed ? (
        <Errors
          inverse={false}
          header="Mohon maaf, permintaan Anda tidak dapat diproses."
          paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
          button={true}
          buttonLabel="Coba lagi"
          buttonAction={onFetchVendor}
        />
      ) : (
        <Card.Body className="mt-0">
          <VendorsTable
            data={data}
            isLoading={isLoading}
            setSortingVendor={setSortingVendor}
            sortField={sortField}
            sortBy={sortBy}
          />
          <Card.Footer>
            <div className="px-4 py-3">
              <Pagination
                disabled={isLoading}
                setLimit={(limit: number) => onChangeLimit(limit)}
                onPageChanged={(page: number) => onChangePage(page)}
                totalRows={pagination.total}
                currentPage={pagination.page}
                limit={limit}
                showLimitPage={true}
              />
            </div>
          </Card.Footer>
        </Card.Body>
      )}
    </Card>
  )
}

export default VendorsIndex
